<template>
  <div
    class="app-item flex items-center w-full p-3 px-5 border vs-list--item cursor-pointer d-theme-dark-bg"
    @click="clickedItem"
  >
    <div class="font-xs text-grey  pr-4">#{{ number }}</div>
    <div class="flex flex-col  text-sm flex-1 md:flex-row md:items-center">
      <div class="flex flex-col md:flex-1 md:pr-5">
        <div class="font-bold ">
          {{ title }}
        </div>
        <div class="font-base">
          <!-- No surat || kode surat -->
          {{ item.perihal }}
        </div>
      </div>
      <div class="flex  justify-between items-center flex-1 ">
        <div class="font-xs text-grey md:flex-1">
          {{
            item.nomor_surat ? item.nomor_surat.nomor : "Nomor belum diambil"
          }}
        </div>
        <div class="">
          <!-- <div class="hidden md:block">
            <StatusLabel :status="item.status" />
          </div> -->
          <div class=""><StatusChip :status="item.status" /></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StatusChip from "./StatusChip.vue";
import StatusLabel from "./StatusLabel.vue";
export default {
  components: {
    StatusLabel,
    StatusChip
  },
  props: {
    item: {
      type: Object
    },
    number: {
      type: Number
    }
  },
  computed: {
    title() {
      if (this.item.tipe == "surat_masuk"){
        return this.item.surat_masuk.pengirim
          ? `Dari : ${this.item.surat_masuk.pengirim}`
          : "Tidak ada pengirim";
      }
      else{
        let tujuan = this.item.surat_keluar.tujuan;
        if(this.item.tujuan.length != 0){
          let tujuanList = [];
          this.item.tujuan.map(item => {
            tujuanList.push(item.nama);
          });
          tujuan = tujuanList.join()
        }
        return this.item.surat_keluar !== null
          ? `Kepada : ${tujuan}`
          : "Tidak ada tujuan";

      }
    }
  },
  methods: {
    clickedItem() {
      // Old way open slide
      // this.$store.dispatch("surat/setDetailId", this.item.id);
      // this.$store.dispatch("globalApp/setShowDetail", true);

      // Route, (new way)
      this.$router.push({
        name: "surat-lihat",
        params: {
          uuid: this.item.uuid
        }
      });
    }
  }
};
</script>

<style lang="scss">
.app-item {
  &:hover {
    // background-color: #fff;
    transform: translateY(-4px);
    box-shadow: 0 3px 10px 0 #ccc;
    transition: all 0.2s;
    -webkit-transition: all 0.2s;
    transition-delay: 0.1s;
  }
}

.theme-dark {
  .app-item {
    &:hover {
      box-shadow: 0 3px 10px 0 #262c49;
    }
  }
}
</style>
